module.exports = function () {
    var productWidth;

    function defineWidth() {
        productWidth = $('.product-slide').innerWidth();
    }

    defineWidth();

    $(window).resize(function () {
        defineWidth();
    });

    for (var i = 0; i <= $('.fruits-display').length; i++) {
        $('#ingredients-slider-' + i).owlCarousel({
            nav: true,
            items: 1,
            autoHeight: true,
            navText: ['<span class="arrow-left"></span>', '<span class="arrow-right"></span>']
        });
        $('#ingredients-slider-' + i).trigger('initialize.owl.carousel');
    }

    $('.fruits-top').on('click', function () {
        $('.fruits-display').not($(this).parent()).removeClass('fruits-active');
        $('.fruits-display').removeClass('fruits-opacity');
        $('.fruits-display').not($(this).parent()).addClass('fruits-opacity');


        if ($(this).parent().hasClass('fruits-active')) {
            $('.fruits-display').removeClass('fruits-opacity');
        }
        $(this).parent().toggleClass('fruits-active');
    });

    $('.ingredients_submenu--name').on('click', function () {
        $('.fruits-display').removeClass('fruits-opacity');
        submenuActive($(this).data('ref'));
        $('.ingredients_submenu--name').removeClass('ingredients-active');
        $(this).addClass('ingredients-active')

    });

    function submenuActive(fruitsRef) {
        var classFruits = '.' + fruitsRef;
        $('.fruits-display').parent().addClass('ingredients-hide');
        $(classFruits).parent().removeClass('ingredients-hide');
        $(classFruits + ':last').parent().addClass('end');
    }

    $('.fruits-display-outer').last().addClass('end');

};
